module.exports = __webpack_public_path__ + "front/img/d11.128e8549.png";